import {
  SET_DISCHARGE_FIELD,
  SET_DISCHARGE_NESTED_FIELD,
  SET_DISCHARGE_ARRAY_ITEM,
  ADD_DISCHARGE_ARRAY_ITEM,
  REMOVE_DISCHARGE_ARRAY_ITEM,
  LOAD_DISCHARGE_SUMMARY_DATA,
  RESET_DISCHARGE_SUMMARY,
  SAVE_DISCHARGE_REQUEST,
  SAVE_DISCHARGE_SUCCESS,
  SAVE_DISCHARGE_FAILURE,
  FETCH_DISCHARGE_REQUEST,
  FETCH_DISCHARGE_SUCCESS,
  FETCH_DISCHARGE_FAILURE,
} from "../actions/dischargeActions";

export const initialDischargeState = {
  // Primary IDs & Flags
  dischSummaryId: null,
  summaryNumber: "",
  patientId: "",
  encounterId: "",
  accountId: "",
  clinicId: "",
  status: 1,
  pageNo: 0,
  pageSize: 10,
  createdBy: "ADMIN",
  createdDate: new Date().toISOString().replace("T", " ").substring(0, 19),
  modifiedBy: "ADMIN",
  modifiedDate: new Date().toISOString().replace("T", " ").substring(0, 19),

  // 1. Clinical Summary
  clinicalSummary: "",

  // 2. Diagnosis (Array of objects)
  dischargeDiagnosis: [
    {
      diagnosisCode: "R50.9",
      diagnosisDesc: "Acute Fever",
      diagnosisSeq: 1,
      diagnosisStatus: "CONFIRMED",
      diagnosisSystem: "ICD10",
      diagnosisType: "PRIMARY",
      presentOnAdmission: "Y",
      remarks: "",
      status: 1,
      activeFlag: "Y",
    },
  ],

  // 3. Clinical Details
  chiefComplaint: "",
  dischargeAllergy: [
    {
      allergyId: "ALG001",
      allergyName: "",
      reaction: "",
      severity: "Moderate",
      comments: "",
      onsetDate: new Date().toISOString().replace("T", " ").substring(0, 19),
    },
  ],

  // 4. Treatment Summary (Object)
  dischargeTreatmentSummary: {
    treatmentId: null,
    ivFluid: "IVF001",
    ivFluidDesc: "Normal Saline",
    oxygenTherapyId: "OXY001",
    oxygenTherapyDesc: "Not Required",
    procedureId: "PROC001",
    procedureDesc: "Routine Medical Management",
    physiotherapyId: "PHY001",
    physiotherapyDesc: "Not Required",
    dietPlanId: "DIET001",
    dietPlanDesc: "Soft Diet",
    surgeryDetails: "No surgery performed.",
    comments: "",
    status: 1,
  },

  // 6. Condition at Discharge
  conditionId: "COND001",
  conditionDesc: "Stable",
  conditionRemarks: "",

  // 7. Medication on Discharge (Array of objects)
  dischargeMedication: [
    {
      medicationId: null,
      drugId: "DRG001",
      drugName: "Paracetamol",
      strength: "650 mg",
      dosage: "1 Tablet",
      frequency: "1-1-1",
      duration: "5 Days",
      route: "Oral",
      instruction: "Take after food with water.",
      startDate: new Date().toISOString().substring(0, 10),
      endDate: new Date(Date.now() + 5 * 24 * 60 * 60 * 1000).toISOString().substring(0, 10),
      displayOrder: 1,
      activeYn: "Y",
      status: 1,
    },
  ],

  // 8. Follow-up
  followupDate: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString().substring(0, 10),
  followupDepartmentId: "DEPT001",
  followupDepartmentDesc: "General Medicine",
  followupDoctorId: "DOC002",
  followupDoctorName: "Dr. Arun Kumar",
  followupInstruction: "",

  // 9. Patient Instructions (Array of objects)
  dischargePatientInstruction: [
    {
      instructionId: 1,
      instrCode: "INS001",
      instrName: "Take prescribed medications regularly.",
      status: 1,
    },
    {
      instructionId: 2,
      instrCode: "INS002",
      instrName: "Complete full course of antibiotics.",
      status: 1,
    },
    {
      instructionId: 3,
      instrCode: "INS003",
      instrName: "Monitor temperature daily.",
      status: 1,
    },
    {
      instructionId: 4,
      instrCode: "INS004",
      instrName: "Avoid self medication.",
      status: 1,
    },
    {
      instructionId: 5,
      instrCode: "INS005",
      instrName: "Return to hospital if symptoms worsen.",
      status: 1,
    },
  ],
  additionalInstruction: "",

  // 10. Diet Advice (Array of objects)
  dischargeDietDtls: [
    {
      dietId: 1,
      dietCode: "DIET001",
      dietName: "Regular Diet",
      status: 1,
    },
    {
      dietId: 2,
      dietCode: "DIET002",
      dietName: "Diabetic Diet",
      status: 1,
    },
  ],

  // 11. Care Plan (Array of objects)
  dischargeCarePlanDtls: [
    {
      carePlanId: 1,
      carePlanCode: "CP001",
      carePlanName: "Light Activity",
      status: 1,
    },
    {
      carePlanId: 2,
      carePlanCode: "CP002",
      carePlanName: "Walking Allowed",
      status: 1,
    },
    {
      carePlanId: 3,
      carePlanCode: "CP003",
      carePlanName: "Avoid Heavy Lifting",
      status: 1,
    },
  ],

  // 12. Disposition
  dispositionId: "DISP001",
  dispositionDesc: "Discharged Home",

  // 13. Doctor Remarks
  doctorRemark: "",

  // 14. Authentication / Actions
  patientCounseled: "Y",
  authDocId: "DOC001",
  authDocName: "Dr. Ramesh Kumar",
  digitalSignature: "base 64 image",
  digitalSignatureType: "jpg",

  // UI state
  isSaving: false,
  saveError: null,
  saveSuccess: false,
};

export const dischargeReducer = (state = initialDischargeState, action) => {
  switch (action.type) {
    case SET_DISCHARGE_FIELD:
      return {
        ...state,
        [action.payload.field]: action.payload.value,
      };

    case SET_DISCHARGE_NESTED_FIELD:
      return {
        ...state,
        [action.payload.parent]: {
          ...state[action.payload.parent],
          [action.payload.field]: action.payload.value,
        },
      };

    case ADD_DISCHARGE_ARRAY_ITEM:
      return {
        ...state,
        [action.payload.arrayName]: [
          ...(state[action.payload.arrayName] || []),
          action.payload.item,
        ],
      };

    case REMOVE_DISCHARGE_ARRAY_ITEM:
      return {
        ...state,
        [action.payload.arrayName]: (state[action.payload.arrayName] || []).filter(
          (_, idx) => idx !== action.payload.index
        ),
      };

    case SET_DISCHARGE_ARRAY_ITEM: {
      const { arrayName, index, field, value } = action.payload;
      const list = [...(state[arrayName] || [])];
      if (list[index]) {
        list[index] = { ...list[index], [field]: value };
      }
      return {
        ...state,
        [arrayName]: list,
      };
    }

    case LOAD_DISCHARGE_SUMMARY_DATA:
      return {
        ...state,
        ...action.payload,
      };

    case RESET_DISCHARGE_SUMMARY:
      return { ...initialDischargeState };

    case SAVE_DISCHARGE_REQUEST:
      return {
        ...state,
        isSaving: true,
        saveError: null,
        saveSuccess: false,
      };

    case SAVE_DISCHARGE_SUCCESS:
      return {
        ...state,
        isSaving: false,
        saveSuccess: true,
        dischSummaryId: action.payload?.dischSummaryId || state.dischSummaryId,
        summaryNumber: action.payload?.summaryNumber || state.summaryNumber,
      };

    case SAVE_DISCHARGE_FAILURE:
      return {
        ...state,
        isSaving: false,
        saveError: action.payload,
        saveSuccess: false,
      };

    default:
      return state;
  }
};
